import { sha256Hash } from '../../utils/events/sha256-hash';

import { type FilterId } from './index';

/**
 * Filter IDs whose selected values are user-generated content (UGC) — for example the free-text
 * label a user typed. The raw value of these filters must never be emitted in analytics; instead we
 * hash it (see `filterSelections`), mirroring how the raw search query is only emitted as
 * `queryHash`.
 *
 * When you introduce a new filter whose selectable values are UGC, add its `filterId` here.
 */
export const UGC_FILTER_IDS: ReadonlySet<FilterId> = new Set<FilterId>(['label', 'tag']);

/**
 * Returns true when the given filter's selected values are UGC and therefore must be hashed before
 * being emitted in analytics.
 */
export const isUgcFilterId = (filterId: string): boolean =>
	UGC_FILTER_IDS.has(filterId as FilterId);

/**
 * Maps a filter selection value to the value that is safe to emit in analytics: UGC filter values
 * (see {@link UGC_FILTER_IDS}) are hashed with sha256 (mirroring queryHash); all other values pass
 * through unchanged.
 */
export const toEmittableFilterValue = (filterId: string, value: string): string =>
	isUgcFilterId(filterId) ? sha256Hash(value) : value;
